import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Navbar,
  Image,
  Nav,
  Button,
  NavDropdown,
} from "react-bootstrap";
import logo from "../../assets/images/logo/logo_h.png";
import { useMediaQuery } from "react-responsive";
import RentNow from "../modals/RentNow";
import SellDevice from "../modals/SellDevice";

const AppNavbar = () => {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const [isScrolled, setIsScrolled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDeviceModal, setShowDeviceModal] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    // <Navbar variant="light" expand="lg" className="m-0 d-none d-lg-block">
    <Navbar variant="light" expand="lg" className="m-0">
      <Container
        fluid
        className="m-0"
        style={{ paddingInline: isDesktopOrLaptop ? "115px" : "30px" }}
      >
        <Navbar.Brand as={Link} to={"/"}>
          <h2 className="txt-white poppins-bold">
            <Image
              src={`${logo}`}
              style={{ height: isDesktopOrLaptop ? "100px" : "130px" }}
              className="img img-fluid"
            />
          </h2>
        </Navbar.Brand>
        {/* <Navbar.Toggle aria-controls="responsive-navbar-nav" /> */}
        <Navbar.Collapse id="responsive-navbar-nav" className="text-white">
          <Nav className="ms-auto d-flex align-items-center ">
            <Nav.Link
              as={Link}
              to={"/accessories"}
              className="navbar-item poppins-bold"
            >
              Buy Accessories
            </Nav.Link>

            <Nav.Link
              as={Link}
              to={"/mobiles"}
              className="navbar-item poppins-bold"
            >
              Buy A Device
            </Nav.Link>
            <Nav.Link
              as={Link}
              onClick={() => {
                setShowDeviceModal(true);
              }}
              // to={"/mobiles"}
              // style={{ borderColor: "#F26D51" }}
              className={
                isDesktopOrLaptop
                  ? "px-3 navbar-item poppins-bold rounded-pill orange-fill-btn"
                  : "navbar-item poppins-bold rounded-pill"
              }
            >
              Sell A Device
            </Nav.Link>
            <Nav.Link
              as={Link}
              to={"/posts"}
              className="navbar-item poppins-bold"
            >
              Blog
            </Nav.Link>
            <Nav.Link
              as={Link}
              onClick={() => {
                setShowModal(true);
              }}
              // to={"/mobiles"}
              // style={{ borderColor: "#F26D51" }}
              className={
                isDesktopOrLaptop
                  ? "px-3 navbar-item poppins-bold rounded-pill orange-fill-btn"
                  : "navbar-item poppins-bold rounded-pill"
              }
            >
              Have a broken Phone ?
            </Nav.Link>
            {/*             
            <Nav.Link as={Link} to="/customer-login" className="navbar-item poppins-bold">
              Login
            </Nav.Link>
            <Nav.Link as={Link} to="/customer-signup" className="navbar-item poppins-bold">
              Signup
            </Nav.Link> */}
          </Nav>
        </Navbar.Collapse>
        <RentNow isVisible={showModal} hideModel={() => setShowModal(false)} />
        <SellDevice isVisible={showDeviceModal} hideModel={() => setShowDeviceModal(false)} />
      </Container>
    </Navbar>
  );
};

export default AppNavbar;
